import { Config } from '../types/config/config';
import { Listing } from '../types/listing/listing';

const MONTH_MAP: { [k: string]: number } = {
    january: 1, february: 2, march: 3, april: 4, may: 5, june: 6,
    july: 7, august: 8, september: 9, october: 10, november: 11, december: 12
};

function parseMonthToNumber(monthName: string): number | null {
    const lower = monthName.toLowerCase().trim();
    if (MONTH_MAP[lower]) {
        return MONTH_MAP[lower];
    }
    const parsed = parseInt(monthName, 10);
    return !isNaN(parsed) ? parsed : null;
}

function parseQuarterEndMonth(quarterName: string): number | null {
    const qNum = parseInt((quarterName + '').replace(/[^0-9]/g, ''), 10);
    if (!isNaN(qNum) && qNum >= 1 && qNum <= 4) {
        return qNum * 3;
    }
    return null;
}

export function isAvailabilityDetailsPast(year: string, monthName?: string, quarterName?: string): boolean {
    if (!year || year === '') {
        return false;
    }

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const numYear = parseInt(year, 10);

    if (isNaN(numYear)) {
        return false;
    }

    if (numYear < currentYear) {
        return true;
    }
    if (numYear > currentYear) {
        return false;
    }

    if (monthName && monthName !== '') {
        const numMonth = parseMonthToNumber(monthName);
        if (numMonth !== null) {
            return numMonth <= currentMonth;
        }
    }

    if (quarterName && quarterName !== '') {
        const quarterEndMonth = parseQuarterEndMonth(quarterName);
        if (quarterEndMonth !== null) {
            return quarterEndMonth <= currentMonth;
        }
    }
    return true;
}

export function isAvailableFromPast(availableFrom: string | Date): boolean {
    if (!availableFrom) {
        return false;
    }
    return new Date(availableFrom) < new Date();
}

export function getAvailableImmediately(config: Config, listing: Listing): boolean {
    if (!config || !config.availableImmediately || !config.availableImmediately.show) {
        return false;
    }
    if (config.availabilityDetails && config.availabilityDetails.show) {
        const details = listing.availabilityDetails || {};
        return isAvailabilityDetailsPast(details.availableYear || '', details.availableMonth, details.availableQuarter);
    }
    if (config.availableFrom && config.availableFrom.show) {
        const availableFrom = listing.availableFrom;
        return availableFrom ? isAvailableFromPast(availableFrom) : false;
    }
    return false;
}
